module.exports = __webpack_public_path__ + "img/diapositiva-2-1.b095f823.png";